const copyTextUsingLegacyExecCommand = (text) => {
    const hiddenTextArea = document.createElement("textarea");
    hiddenTextArea.value = text;
    hiddenTextArea.setAttribute("readonly", "");
    hiddenTextArea.style.position = "fixed";
    hiddenTextArea.style.top = "-1000px";
    hiddenTextArea.style.opacity = "0";
    document.body.appendChild(hiddenTextArea);
    hiddenTextArea.select();
    try {
        return document.execCommand("copy");
    }
    finally {
        document.body.removeChild(hiddenTextArea);
    }
};
const isModernClipboardAvailable = () => typeof navigator !== "undefined" && typeof navigator.clipboard?.writeText === "function";
const platformClipboardWeb = {
    adapterName: "web",
    async writeText(text) {
        if (isModernClipboardAvailable()) {
            try {
                await navigator.clipboard.writeText(text);
                return;
            }
            catch {
                // navigator.clipboard.writeText rejects outside a secure context or a
                // user gesture, or when the permission is denied; try the legacy path.
            }
        }
        const didLegacyCopySucceed = copyTextUsingLegacyExecCommand(text);
        if (!didLegacyCopySucceed) {
            throw new Error("clipboard write failed: navigator.clipboard unavailable or rejected, and the execCommand fallback returned false");
        }
    },
};
export default platformClipboardWeb;
